<style>
  .nav>a{padding-right:12px !important;}
</style>
<template>
  <!--header-->
  <div class="box header">
    <div class="wrap w1200">
      <div class="col_1 w296 logo" @click="toIndex">
        <img v-if="currentOrg && currentOrg.logo" :src="currentOrg.logo"/>
        <img v-if="!currentOrg || !currentOrg.logo" src="./images/logo@2x.png" style="width: auto;" />
      </div>
      <div class="col_2 w810">
        <div class="col_2_1 w570 nav"><router-link to="/">首页</router-link><router-link to="/byl/courseList">课件学习</router-link><router-link to="/byl/characteristic">平台特色</router-link><a href="">APP下载</a><router-link to="/byl/teacherList">优秀讲师</router-link><router-link to="/byl/examList">在线考试</router-link><a target="_blank" href="http://www.byl.sh.cn/education/index.html">远程教学</a></div>
        <div class="col_2_2 w140 header_r">
          <div v-if="!token">
            <!--a href="javascript:;" @click="toParent('reg')">企业入驻</a><span>|</span--><a href="javascript:;" @click="toParent('login')">员工登录</a>
          </div>
          <div class="col_2 top_right_menu" v-if="token">
            <ul>
              <li>
                <label @click="toParent('record')" style="cursor: pointer;" v-if="isAdmin">{{txt}}</label>
                <ol>
                  <p>
                    <span>
                      <img :src="fuser.head" alt="" v-if="fuser && fuser.head">
                      <img src="./images/member_header.png" title="头像" v-if="!fuser || !fuser.head" />
                      <dl class="kuang_b">
                        <div>
                          <dt>
                            <router-link :to="{path: '/byl/uc/record'}">我的课程</router-link>
                            <router-link :to="{path: '/byl/uc/fav'}" class="icon_b">我的收藏</router-link>
                            <router-link :to="{path: '/byl/uc/examination'}" class="icon_c">我的考试</router-link>
                            <router-link :to="{path: '/byl/uc/enroll'}" class="icon_e">我的报名</router-link>
                            <router-link :to="{path: '/byl/uc/certificate'}" class="icon_d">我的证书</router-link>
                            <router-link :to="{path: '/byl/uc/message'}" class="icon_e">我的消息</router-link>
                            <router-link :to="{path: '/byl/uc/order'}" class="icon_b">我的订单</router-link>
                          </dt>
                          <dd>
                            <router-link :to="{path: '/byl/uc/set'}" class="icon_b">资料设置</router-link>
                            <a href="javascript:void(0);" class="icon_g" @click="toParent('logout')">退出登录</a>
                          </dd>
                        </div>
                      </dl>
                    </span>
                    <span>
                      <span v-if="fuser && fuser.nickname">{{fuser.nickname}}</span><span v-if="!fuser || !fuser.nickname">游客</span><br />
                      <i v-if="currentOrg" class="arrow_i">{{currentOrg.name}}</i>
                      <i v-if="!currentOrg" class="arrow_i">默认机构</i>
                      <div class="arrow_icon"></div>
                      <dl class="kuang_a" v-if="fuser">
                        <div>
                          <div style="height: 220px;">
                            <vue-scroll :ops="ops">
                              <a v-for="org in orgs" :key="org.id" @click="toOtherOrg(org)">
                                <dt>
                                  <img :src="org.logo" alt="" v-if="org.logo">
                                  <img src="./images/jg_icon.jpg" alt="" v-if="!org.logo">
                                  <span v-if="fuser && fuser.nickname">{{fuser.nickname}}</span><span v-if="!fuser || !fuser.nickname">游客</span><br /><b>{{treatName(org.name)}} <span v-if="org.id == getCurrentOrg.id">[当前]</span></b>
                                </dt>
                              </a>
                            </vue-scroll>
                          </div>
                          <dd @click="toParent('reg')"><a>注册新企业</a></dd>
                        </div>
                      </dl>
                      <dl class="kuang_a" v-else>
                        <div><a href="">暂无企业</a></div>
                        <dd @click="toParent('reg')"><a>注册新企业</a></dd>
                      </dl>
                    </span>
                  </p>
                </ol>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--/header-->
</template>
<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { getCookie } from '@/store/cookies.js'
  import api from '@/api/index'
  import config from '@/config/index'
  import utils from '@/utils'
export default {
  name: 'Header',
  components: {  },
  data () {
    return {
      fuser: {}, // 当前用户
      currentOrg: {}, // 当前机构
      orgs: [], // 机构列表
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {
          background: '#bbb'
        },
        bar: {
          background: '#e73936'
        }
      },
      isAdmin: false
    }
  },
  mounted () {
    this.$VD.setVal('$TOKEN_VAL', getCookie('token'))
    if (getCookie('user')) {
      this.getOrgs(getCookie('user'))
    }
    if (getCookie('org')) {
      this.currentOrg = getCookie('org')
    }
    if (getCookie('token')) {
      this.getRoles() // 当前机构切换以后要重新去取用户角色
    }
  },
  watch: {
    user (val) {
      if (val) {
        this.fuser = val
        this.orgs = val.orgs
      }
    },
    getCurrentOrg (val) {
      if (val) {
        this.currentOrg = val
      }
    },
    getCurrentRoles (val) {
      this.fuser.roleList = utils.grabVal(val, 'role')
      this.isAdmin = this.isPlatAdmin(this.fuser.roleList) || this.isOrgAdmin(this.fuser.roleList) // 是平台管理员或者机构管理员
    }
  },
  computed: {
    ...mapState('auth', ['token', 'user']),
    ...mapGetters('auth', ['getCurrentOrg', 'getCurrentRoles'])
  },
  methods: {
    ...mapActions('auth', {
      getOrgs: 'getOrgs',
      getRoles: 'getRoles',
      setCurrentOrg: 'setCurrentOrg'
    }),
    toParent (page) {
      this.$emit(`to-${page}`)
    },
    toIndex () {
      this.$router.push('/byl/index')
    },
    isPlatAdmin (roles) {
      if (roles) {
        return utils.findElem(roles, 'type', '1') > -1
      }
      return false
    },
    isOrgAdmin (roles) {
      if (roles) {
        return utils.findElem(roles, 'type', '2') > -1
      }
      return false
    },
    treatName (val) {
      return (val.length > 12) ? val.substring(0, 12) : val
    },
    saveUser (org) {
      let o = {
        userId: this.user.id,
        orgId: org.id,
        sign: '2',
        isOpen: org.isOpen
      }
      api.post(config.bylApiPath, '/entUser/save', o, r => {})
    },
    toOtherOrg (org) {
      this.saveUser(org)
      if (org.isOpen == '1') {
        this.setCurrentOrg(org)
      } else if (org.isOpen == '0') {
        this.$toasted.show('机构非公开')
      }
    }
  },
  props: ['txt']
}
</script>
<style scoped>
  @import './header.css';
</style>



// WEBPACK FOOTER //
// src/components/byl/header/header.vue